<template>
    <div class="grid max-w-xl grid-cols-1 gap-x-4 gap-y-4 py-2">
        <BaseInputCheckbox
            v-model="checkAll"
            class="border-b border-gray-300 pb-4 font-semibold"
            :label="$t('acknowledgements.check_all')"
            name="account.acknowledgements.check_all"></BaseInputCheckbox>
        <LegalAcknowledgementsOneFormFields v-model="formValues"></LegalAcknowledgementsOneFormFields>
        <LegalAcknowledgementsTwoFormFields v-model="formValues"></LegalAcknowledgementsTwoFormFields>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getLegalWidgetFormValidationRules, initializeLegalWidgetForm, LegalAcknowledgements } from './forms'
import { useVModel } from '@vueuse/core'
import LegalAcknowledgementsOneFormFields from './acknowledgements/LegalAcknowledgementsOneFormFields.vue'
import LegalAcknowledgementsTwoFormFields from './acknowledgements/LegalAcknowledgementsTwoFormFields.vue'
import BaseInputCheckbox from '../../../../base/BaseInputCheckbox.vue'

const checkAll = computed({
    get() {
        return Object.keys(formValues.value).every((key) => {
            return formValues.value[key]
        })
    },
    // setter
    set(newValue) {
        if (newValue) {
            Object.keys(formValues.value).forEach((key) => {
                formValues.value[key] = true
            })
        } else {
            Object.keys(formValues.value).forEach((key) => {
                formValues.value[key] = false
            })
        }
    },
})

const props = defineProps<{
    modelValue: LegalAcknowledgements
}>()
const emit = defineEmits(['update:modelValue'])

const formValues = useVModel(props, 'modelValue', emit)

const allAcknowledgementRules = getLegalWidgetFormValidationRules('acknowledgements')

initializeLegalWidgetForm(allAcknowledgementRules)
</script>

<style scoped></style>
